module.exports = __webpack_public_path__ + "media/applicants/your-privacy-choices-icon-50529423.svg";